import { useNavigate } from "react-router-dom";

export const RecipeCard = ({ recipe }) => {
  const navigate = useNavigate();
  const handleClick = () => navigate(`/recipes/${recipe?.sid}`, { state: { recipe } });

  return (
    <li
      onClick={handleClick}
      className="card p-4 cursor-pointer hover:border-teal-600"
    >
      <div className="font-medium text-stone-800">{recipe?.name}</div>
      <div className="text-sm text-stone-500">{recipe?.fromTheKitchenOf}</div>
      <div className="flex gap-4 text-sm text-stone-500 mt-1">
        <span>{recipe?.calories} cal</span>
        <span>{recipe?.totalTime}</span>
      </div>
    </li>
  );
};

const RecipeRow = ({ recipe, onClick }) => {
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`/recipes/${recipe?.sid}`, { state: { recipe } });
  };

  return (
    <tr onClick={handleRowClick} className="cursor-pointer hover:bg-stone-100">
      <td className="px-3 py-2">{recipe?.name}</td>
      <td className="px-3 py-2">{recipe?.calories}</td>
      <td className="px-3 py-2">{recipe?.fromTheKitchenOf}</td>
      <td className="px-3 py-2">{recipe?.totalTime}</td>
    </tr>
  );
};
export default RecipeRow;
